/**
 * @deprecated
 */
export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

/**
 * @deprecated
 */
export interface SortOptions {
  readonly [column: string]: SortOrder;
}

/**
 * @deprecated
 */
export interface QueryOptions {
  readonly order_by: SortOptions[];
  readonly results_per_page: number;
  readonly page_number: number;
}

/**
 * @deprecated
 */
export interface PaginateProps {
  /**
   * The id of the button
   */
  readonly id?: string;

  /**
   * total number of rows the API says there are
   */
  readonly resultsTotalCount: number;

  /**
   * Query options from the api
   */
  readonly queryOptions: QueryOptions;

  /**
   * Hide the amount description
   */
  readonly displayDescription?: boolean;

  /**
   * The test id of the icon
   */
  readonly testId?: string;

  /**
   * Paginate needs to be able to call this function that fetches new data and changes state.
   */
  readonly handleUpdateRequest: (option: QueryOptions) => void;

  /**
   * there are more rows in the db than the API response MAX_COUNT_RESULTS
   */
  readonly resultsMoreFlag?: boolean;
}
